import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect } from 'react';
import useCombinedRefs from '../hooks/useCombinedRefs';
const inputStyle = {
    height: '100%',
    width: '100px',
    borderRadius: '5px',
    border: '0.55px solid #c7c7c7',
    textAlign: 'center',
};
const NumberInput = forwardRef(({ name, value: valueProp, style = {}, onChange, pattern = '^\\d*.\\d*$', step = 'any', min = 'any', max = 'any', autoSelect = false, ...otherProps }, ref) => {
    const combinedRef = useCombinedRefs([ref]);
    useEffect(() => {
        if (autoSelect) {
            combinedRef?.current?.select();
        }
    }, [autoSelect, combinedRef]);
    return (_jsx("input", { ref: combinedRef, name: name, style: { ...inputStyle, ...style }, type: "number", pattern: pattern, value: valueProp, step: step, onChange: onChange, min: min, max: max, ...otherProps }));
});
export default NumberInput;
